export default __webpack_public_path__ + "static/media/allwebsite.4f936c35.png";